import { render } from "./mealRecord.vue?vue&type=template&id=4874e7f9&scoped=true"
import script from "./mealRecord.vue?vue&type=script&lang=js"
export * from "./mealRecord.vue?vue&type=script&lang=js"

import "./mealRecord.vue?vue&type=style&index=0&id=4874e7f9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4874e7f9"]])

export default __exports__